import Swiper from "swiper"
import "swiper/css"

class WorksTeaserHandler {
  constructor(root = document) {
    this.sliders = Array.from(root.querySelectorAll(".works-teaser__slider"))
    this.sliders.forEach(slider => this.init(slider))
  }

  init(slider) {
    new Swiper(slider, {
      slidesPerView: 1.15,
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        640: {slidesPerView: 2.2},
        768: {slidesPerView: 2.5},
        1024: {slidesPerView: 3.5},
      },
    })
  }
}

export default WorksTeaserHandler
